import Box from 'ui/src/components/Box'
import IconButton from 'ui/src/components/IconButton'
import { useNavigate } from 'react-router-dom'
import MarketplaceSvg from 'ui/src/assets/icons/marketplace.svg?react'
import { Tooltip } from 'ui/src/components/Tooltip'

const Referrals = () => {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Tooltip title="Marketplace">
        <IconButton
          onClick={() => {
            navigate('/company/marketplace')
          }}
          sx={{ width: '100%', height: '100%', cursor: 'pointer' }}
        >
          <MarketplaceSvg
            data-cy="marketplace"
            style={{
              height: '1.25rem',
              width: '1.25rem',
            }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default Referrals
